import type { HelpFile } from '../../types/help'
import { ExistingPartySelectorTestIds } from '../../../testids/ExistingPartySelectorTestIds'

export const existingPartySelectorHelp: HelpFile = {
  docPage: '/docs/onboarding/existing-party',
  texts: {
    [ExistingPartySelectorTestIds.existingPartySelector]:
      'Dieses Onboarding an eine bestehende Partei anhängen, statt ein Duplikat anzulegen.',
  },
}
